import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["canSelect", "children", "disabled", "role"];
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { LayoutGrid } from '../Layout/LayoutGrid';
import { useGridList } from './useGridList';
import { jsx as _jsx } from "react/jsx-runtime";
export const canSelectStyles = css(["&.can-select{transition:background-color 0.2s ease-in-out;}&.can-select-disabled{cursor:not-allowed;}&.can-select:hover,&.can-select:focus,&.can-select:focus-visible,&.can-select:focus-within{background:", ";}"], ({
  theme
}) => theme.color['fill-tertiary-hover']);
const StyledSelectableRow = styled(LayoutGrid).withConfig({
  displayName: "GridListRowContainer__StyledSelectableRow",
  componentId: "sc-1568jjx-0"
})(["", ""], canSelectStyles);
export const GridListRowContainer = _ref => {
  let {
      canSelect,
      children,
      disabled,
      role = 'row'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    gapColumn,
    gapRow,
    gridTemplateColumns
  } = useGridList();
  return /*#__PURE__*/_jsx(StyledSelectableRow, Object.assign({}, rest, {
    $disabled: disabled,
    className: classNames(disabled ? 'can-select-disabled' : canSelect && 'can-select'),
    gapColumn: gapColumn,
    gapRow: gapRow,
    gridTemplateColumns: gridTemplateColumns,
    role: role,
    children: children
  }));
};